/**
 * AI Policies Page — Tenant-scoped AI safety controls.
 * Contains per-tenant kill switch and future policy configuration.
 * Phase 4.7 — WQ-178
 */
import React from 'react';
import { useAdminContext } from '../contexts/AdminContextProvider';
import TenantKillSwitchCard from '../features/tenants/components/TenantKillSwitchCard';
import AIPoliciesKillSwitchControl from '../components/policies/AIPoliciesKillSwitchControl';

const AIPoliciesPage: React.FC = () => {
  const { activeTenant } = useAdminContext();

  if (!activeTenant?.id) {
    return (
      <div style={{ padding: 40, textAlign: 'center', color: 'var(--text-secondary)' }}>
        Enter a tenant context to manage AI policies.
      </div>
    );
  }

  return (
    <div style={{ padding: '0 16px' }}>
      <div className="page-header">
        <h2 className="page-title">AI Policies</h2>
      </div>

      <p style={{ color: 'var(--text-secondary)', fontSize: 13, marginBottom: 20 }}>
        AI safety controls for <strong>{activeTenant.name}</strong>. Manage kill switches, model access, and operational limits.
      </p>

      {/* Per-Tenant Kill Switch (Redis-backed global tenant halt — WQ-041) */}
      <div style={{ marginBottom: 24 }}>
        <TenantKillSwitchCard tenantId={activeTenant.id} tenantName={activeTenant.name} />
      </div>

      {/* Per-Capability Kill Switch (DB-backed per-tenant per-capability — WQ-232) */}
      <AIPoliciesKillSwitchControl />

      {/* Future policies placeholder */}
      <div style={{
        padding: 20, borderRadius: 8,
        border: '1px dashed var(--border)',
        color: 'var(--text-secondary)', fontSize: 13, textAlign: 'center',
      }}>
        Additional AI policies (model access, token limits, allowed capabilities) will be available in Phase 4.8.
      </div>
    </div>
  );
};

export default AIPoliciesPage;
